export const FEATURES = {
    COMMERCIAL_LINK: 'commercial_link',
    CUSTOM_MESSAGE: 'custom_message',
    FORCE_REGISTRATION: 'force_registration',
    NEW_VIEWER: 'new_viewer',
    SHOW_ON_VIEWER_PHONE: 'show_on_viewer_phone',
};
export const VIDEO_STATUS = {
    pending: 'PENDING',
    uploading: 'UPLOADING',
    uploadingFailed: 'UPLOAD_FAILED',
    uploaded: 'UPLOADED',
    allocating: 'ALLOCATING',
    allocated: 'ALLOCATED',
    allocateFailed: 'ALLOCATE_FAILED',
    streaming: 'STREAMING',
    streamingFailed: 'STREAMING_FAILED',
    closing: 'CLOSING',
    archiving: 'ARCHIVING',
    archivingFailed: 'ARCHIVING_FAILED',
    archived: 'ARCHIVED',
    archivedS3: 'ARCHIVED_S3',
    closed: 'CLOSED',
    expired: 'EXPIRED',
    retrieving: 'RETRIEVING',
    retrieved: 'RETRIEVED',
    notfound: 'ERROR', // This is an abitary value; do we have an error code for 'event not found'?
};
export const RELATIONSHIP_OPTIONS = [
    {
        label: 'Immediate family',
        value: 'Immediate family',
    },
    {
        label: 'Extended family',
        value: 'Extended family',
    },
    {
        label: 'Classmate',
        value: 'Classmate',
    },
    {
        label: 'Colleague',
        value: 'Colleague',
    },
    {
        label: 'Friend',
        value: 'Friend',
    },
    {
        label: 'Other',
        value: 'Other',
    },
    {
        label: 'Prefer not to say',
        value: 'Prefer not to say',
    },
];
export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});
// 30 days
export const FINGERPRINT_COOKIE_LIFESPAN = 60 * 60 * 24 * 30;
export const FEEDBACK_FORM_COOKIE_LIFESPAN = 60 * 60 * 24 * 30;
